import { render } from "./SelectTable.vue?vue&type=template&id=2d35dd86&scoped=true"
import script from "./SelectTable.vue?vue&type=script&lang=js"
export * from "./SelectTable.vue?vue&type=script&lang=js"

import "./SelectTable.vue?vue&type=style&index=0&id=2d35dd86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d35dd86"]])

export default __exports__